// extracted by mini-css-extract-plugin
module.exports = {"selectorLink":"UnitSelector_selectorLink__Khh4y"};